import { animateBanners } from "./animations";
import initRegretForm from "./regretForm";
import initTotalsUpdateListener from "./totals";
import focusOnInputError from "./focusOnInputError";
import initSearchInput from "./searchInput";
import copyText from "./copyText";

const initComponents = () => {
    animateBanners();
    initRegretForm();
    initTotalsUpdateListener();
    focusOnInputError();
    initSearchInput();
    copyText();
};

export default initComponents;
